import { Pipe, PipeTransform } from '@angular/core';
import { StaticResourceService } from '@core/services/static-resource.service';

@Pipe({
  name: 'gcAddStaticResourceSAS',
  pure: true
})
export class AddStaticResourceSASPipe implements PipeTransform {

  constructor (
    private staticResourceService: StaticResourceService
  ) { }

  transform (
    url: string
  ) {
    if (!!url) {
      if (!!this.staticResourceService.sas) {
        url = url +
          (url.includes('?') ? '&' : '?') +
          this.staticResourceService.sas.split('?')[1];
      }
    }

    return url;
  }
}
